import { useIsEmbed } from 'src/shared/hooks';

/**
 * This controls whether selecting AI segmentation subregions to apply changes
 * in the edit experience is enabled. Currently this functionality is disabled
 * for the embed experience, but we can update this hook to control when this
 * feature is enabled going forward.
 */
export const useIsSubregionSelectionEnabled = () => !useIsEmbed();
